<template>
  <div id="app" :class="isPC?'pcWeb':''">
    <!-- 客户端下载提示 -->
    <div class="app-down-banner" v-if="isPC">
      <div class="banner-logo">
        <img src="@assets/image/app/banner-logo.png" alt />
      </div>
      <a class="down-logo" :href="appUrl">下载APP</a>
    </div>

    <!-- 这里是会被缓存的视图组件，比如列表A页面 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>

    <!-- 这里是不被缓存的视图组件，比如详情B页面-->
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- tabbar组件 -->
    <MainTabBar v-if="isTabbarShow" />
  </div>
</template>
<script>
import { contTools, lyTool } from "./mixins/contMixins";
import MainTabBar from "@components/content/mainTabbar/MainTabBar";
import wapApiFun from "./servers/wap-module/apiFun";
import comTools from "./assets/js/until";
export default {
  name: "App",
  mixins: [contTools, lyTool],
  components: {
    MainTabBar,
  },
  data() {
    return {
      apiData: {},
      isTabbarShow: false, // 是否显示tabbar
      appUrl: this.$store.state.apkAppUrl, // app下载链接
    };
  },
  watch: {
    $route: {
      handler: function (newPath, oldPath) {
        if (newPath.meta.isTabbarShow) {
          this.isTabbarShow = true;
        } else {
          this.isTabbarShow = false;
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  computed: {},
  created() {
    this.device();
    this.getUrlParams();
    // console.log('dd',this.$store.state.apkAppUrl);
  },
  mounted() {},
  methods: {
    // 设备上报
    device() {
      // console.log("this.wapConfig()", this.wapConfig());

      let _isIos = comTools.isIos() ? "ios" : "android";
      let urlObj = comTools.getRequest();
      let data = comTools.assignObj(this.wapConfig(), {
        app_pid: comTools.isIos() ? 101 : 102,
        client_type: _isIos || "h5",
        client_id: urlObj.client_id || this.getIdfa(),
        client_idv:
          urlObj.client_idv || this.getIdfa() || urlObj.client_id || "",
        device_id:
          urlObj.device_id ||
          this.getMd5(`${urlObj.client_id}${urlObj.client_idv}`),
        sdk_ver: urlObj.sdk_ver || "v1.0",
        package_name: urlObj.package_name || "h5",
        wpi: urlObj.wpi || "",
        hpi: urlObj.jpi || "",
        device_brand: urlObj.device_brand || "",
        device_model: urlObj.device_model || "",
        net: urlObj.net || "",
        net_name: urlObj.net_name || "",
      });
      // let data = {
      //   app_pid: urlObj.glPid || 100,
      //   app_gid: urlObj.glGid || 1001,
      //   app_p_mid: urlObj.glPMid || "1",
      //   app_mid: urlObj.glMid || "10000",
      //   tm: comTools.getTm(),
      //   client_type: urlObj.client || "h5"
      // };
      data.sign = comTools.querySort(data);
      wapApiFun.device(data).then((res) => {
        console.log(res);
      });
    },
    // 获取地址栏参数存至本地
    getUrlParams() {
      this.$store.commit("setWapConfig");
    },
  },
};
</script>
<style lang='less'>
@import "./assets/css/base.css";
@import "./assets/css/com.less";
#app {
  width: 100%;
  font-family: PingFang SC, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
  // -webkit-font-smoothing: antialiased;
  margin: 0 auto;
  background-color: #fff;
  // overflow-y: overlay;
  // -webkit-overflow-scrolling: touch;
  .app-down-banner {
    width: 100%;
    height: 1.6rem;
    background-color: #fff;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999999;
    .jc-around();
    .banner-logo {
      width: 2rem;
      img {
        .img();
      }
    }
  }
  &.pcWeb {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    border: 1px solid #ddd;
    border-radius: 0.2rem;
    overflow: auto;
    #tab-bar {
      position: absolute;
      bottom: -1px;
      border-radius: 0.2rem;
    }
    .app-down-banner {
      height: 2.5rem;
      .banner-logo {
        width: 6rem;
      }
      .down-logo {
        color: #ff971c;
      }
    }
  }
  .collect-wrapper {
    width: 100%;
    height: 100%;
    // background-color: #fff;
    .flex-column(space-between);
    .downBar {
      width: 100%;
      min-height: 52px;
      background-color: #fff;
      padding-left: 0.2rem;
      padding-right: 0.2rem;
      box-sizing: border-box;
      .jc-between();
      .banner-logo {
        width: 4rem;
        img {
          .img();
        }
      }
      .down-logo {
        // border: 1px solid #ff971c;
        padding: 0.1rem 0.5rem;
        color: #ff971c;
      }
    }
    .collectBox {
      width: 50%;
      margin: 2rem auto;
      margin-left: 3.5rem;
      position: relative;
      .close-collect {
        position: absolute;
        right: 0;
        top: 0;
        width: 1rem;
        height: 1rem;
      }
      img {
        .img();
        // background-color: #ccc;
      }
    }
  }
}
</style>
